/**
 * 再生速度の候補と巡回ロジック。
 * 動画個別ページ・埋め込み（SP/PC モーダル・インタラクティブ）で同じ順序を共有する。
 */
export const PLAYBACK_SPEEDS = [1, 1.2, 1.5, 2] as const

/** 現在の速度の次の速度を返す（末尾の次は先頭へ戻る。候補外の値は先頭扱い）。 */
export function nextPlaybackRate(current: number): number {
  const currentIndex = PLAYBACK_SPEEDS.indexOf(current as (typeof PLAYBACK_SPEEDS)[number])
  const nextIndex = (currentIndex + 1) % PLAYBACK_SPEEDS.length
  return PLAYBACK_SPEEDS[nextIndex]
}
